import { NonUndefined } from "helpers/utility/types";
import { FeatureFlagView } from "models/dbModels/featureFlags/FeatureFlag";
import React from "react";
import { useAppSelector } from "redux/hooks";

export const ZFlags = {
    ZFreedom: {
        Dashboards: {
            Operations: "ZFreedom.Dashboards.Operations",
        },
        ManagedStock: {
            StockConflicts: "ZFreedom.ManagedStock.StockConflicts",
            AgGrid: "ZFreedom.ManagedStock.AgGrid"
        },
        Reports: {
            Experimental: "ZFreedom.Reports.Experimental",
            Group: {
                Stock: "ZFreedom.Reports.Group.Stock"
            }
        },
        Stores: {
            LockDownFields: "ZFreedom.Stores.LockDownFields",
        },
        SupplierDeals: {
            StockDeals: "ZFreedom.SupplierDeals.StockDeals",
            AssortedDeals: "ZFreedom.SupplierDeals.AssortedDeals",
        }
    },
    
} as const;

export function getFeatureFlagValue(flags: FeatureFlagView[], flagPath: ZFeatureFlagPath) : any {
    if (!flags) return undefined;
    
    const flagName = getFlagName(flagPath);
    const flag = flags.find(flag => flag.flagName.toLowerCase() === flagName.toLowerCase());
    if (flag) {
        return flag.flagValue;
    }
    return null;
}

function getFlagName(path: ZFeatureFlagPath): string {
    const parts = path.split('.') as Array<keyof typeof ZFlags>;
    let current: any = ZFlags;
    for (const part of parts) {
        current = current[part];
    }
    return current;
}


// All of these types are just to be able to fetch the flag using the object path as a string (and have autocomplete too),
// this way we can have proper errors show up if our permission doesn't match an expected path.
type PathValue<T, K extends keyof T> = K extends string
  ? T[K] extends Record<string, any>
    ? `${K}.${ZFlagPaths<T[K]>}`
    : `${K}`
  : never;

type ZFlagPaths<T> = {
    [K in keyof T]: PathValue<T, K>
}[keyof T];

export type ZFeatureFlagPath = ZFlagPaths<typeof ZFlags>;

type ZFeatureFlagComponentProps = {
    flag: ZFeatureFlagPath,
    value: NonNullable<unknown> | null,
    children?: React.ReactNode,
}

/**
 * Shows the child element if the corresponding flag is equal to the given value
 * @param flag The exact flag to check
 * @param value The value to check the given flag against, this value cannot be undefined.
 * @param children The element to render if the given value is equal to the given flag
 */
export function ZFeatureFlag({ flag, value, children }: ZFeatureFlagComponentProps): JSX.Element {
    const global = useAppSelector((state) => state.global);
    return (
        <>
            {getFeatureFlagValue(global.featureFlags, flag) === value
                && children}
        </>
    );
}